import { MediaProgramWithGuides } from '@/utils/media/types';
import { RbcReason, UsercryptMultiselect } from '@calm/evexia-web-sdk';
import React from 'react';

export interface LearnWhyProps {
    isTopRecommendation: boolean;
    reason: RbcReason;
    packClass: string;
    program: MediaProgramWithGuides;
}

export enum MatchingPod {
    Goals,
    Topics,
    Conditions,
    AgeGender,
    Age,
    Gender,
}

export interface MatchingChoice {
    icon: React.JSX.Element;
    label: string;
    displayName?: string;
    category?: {
        id: string;
        name: string;
    };
}

export interface MatchingChoicesPodData {
    totalCount: number;
    matchingChoices: MatchingChoice[];
}

export interface GetMatchingChoicesPodData {
    matchingChoices: string[] | undefined;
    totalCount: number | undefined;
    pod: MatchingPod;
    choiceMetadata?: UsercryptMultiselect;
}
